import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import PanelLayout from '../panel/layout';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';
import Title from './title';
import WorkDetails from './work_details';
import WallGroup from './wall_group';
import Const from '../../config/const';

const renderWork = (
  workExtended,
  index,
  removeFromCanvas,
  addToCart,
  currency
) => {
  const {
    zoomPreviewUrl,
    title
  } = workExtended;
  if (!title) {
    return null;
  }
  const remove = () => removeFromCanvas(index);

  const addWorkCart = () => addToCart(index);

  return (
    <div className={ classes.work } key={ index }>
      <div className={ classes.img }>
        <img src={ zoomPreviewUrl } alt={ title } />
        <button className={ classes.remove } onClick={ remove } name="remove" type="button">
          &times;
        </button>
      </div>
      <WorkDetails { ...workExtended } currency={ currency } />
      <div className={ classes.addToCart } onClick={ addWorkCart }>
        <Button>ADD TO CART</Button>
      </div>
    </div>
  );
};

const Info = ({
  groups, indexOf, closePanel, removeFromCanvas, addToCart, addWallGroupToCart, currency, ...rest
}) => (
  <PanelLayout
    title={ <Title { ...rest } /> }
    onClose={ () => closePanel(Const.panelKinds.info) }
  >
    <div className={ shared.container }>
      <div className={ shared.holder }>
        <div className={ shared.scroll }>
          {
            groups.map((group) => (
              <div className={ classes.group } key={ group.sourceWallId || 'loose' }>
                <WallGroup
                  { ...group }
                  count={ group.works.length }
                  currency={ currency }
                  onAddGroup={ () => addWallGroupToCart(group.works, group.sourceWallId) }
                />
                {
                  group.works.map((work) => {
                    const index = indexOf(work);
                    // -1 means the work is not in canvas.works — every such item would
                    // collide on key={-1} and removeFromCanvas(-1) would drop the wrong row.
                    return index < 0 ? null : renderWork(
                      work, index, removeFromCanvas, addToCart, currency
                    );
                  })
                }
              </div>
            ))
          }
        </div>
      </div>
    </div>
  </PanelLayout>
);

Info.propTypes = {
  closePanel: PropTypes.func.isRequired,
  removeFromCanvas: PropTypes.func.isRequired,
  groups: PropTypes.array.isRequired,
  indexOf: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  addWallGroupToCart: PropTypes.func.isRequired,
  // the rest
  name: PropTypes.string,
  currency: PropTypes.string
};

export default Info;
